export default __webpack_public_path__ + "static/media/icon-expand.32c1644c.svg";